// extracted by mini-css-extract-plugin
export default {"tasks-container":"Tasks_tasks-container__RdUeJ","title":"Tasks_title__-Uamz","title-update-container":"Tasks_title-update-container__5Ogl7","no-tasks":"Tasks_no-tasks__gpiPL"};